export default __webpack_public_path__ + "static/media/sticker-u.3d241cbb.png";